import React, { useEffect, useState } from "react";
import Navbar from "../../components/Header";
import axios from "axios";
import Content from "./Content";
import Footer from "../../components/Footer";
import HeroSection from "../../components/RentRealEstate/Herosection";

function ResidentialRealEstate() {
  let [data, setData] = useState([]);
  let [filterData, setFilterData] = useState([]);
  const [searchResult, setSearchResult] = useState(null);

  useEffect(() => {
    async function getData() {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/properties/approved-residential`);
        setData(res.data);
        setFilterData(res.data);
      } catch (err) {
        console.error('Error fetching commercial properties:', err);
        setData([]);
        setFilterData([]);
      }
    }

    getData();
  }, []);

  function handleFilter(searchResult) {
    setFilterData(data);
    console.log(searchResult);
    if (searchResult.city !== "Dubai") {
      setFilterData((prev) => {
        return prev.filter((property) =>
          property.location.includes(searchResult.city)
        );
      });
    }
    if (searchResult.propertyType !== "Any") {
      setFilterData((prev) => {
        return prev.filter((property) => {
          return property.propertyType === searchResult.propertyType;
        });
      });
    }
    if (searchResult.price !== "Any") {
      setFilterData((prev) => {
        return prev.filter((property) => {
          return parseInt(property.price) > parseInt(searchResult.price);
        });
      });
    }
    if (searchResult.complete !== "Any") {
      setFilterData((prev) => {
        return prev.filter((property) => {
          return property.propertyStatus === searchResult.complete;
        });
      });
    }
  }

  return (
    <div>
      <Navbar />
      <HeroSection
        searchResult={searchResult}
        setSearchResult={setSearchResult}
        handleFilter={handleFilter}
      />
      <Content data={filterData} />
      <Footer />
    </div>
  );
}

export default ResidentialRealEstate;
